import { render, staticRenderFns } from "./MPColors.vue?vue&type=template&id=3d727caf&"
import script from "./MPColors.vue?vue&type=script&lang=js&"
export * from "./MPColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports